import { Typography } from '@mui/material';
import { SuppliersContext } from 'Context/SuppliersContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { SUPPLIERS_ID } from 'Enum/suppliers';
import { useDictionary } from 'Hooks';
import { useContext } from 'react';

export const Title = () => {
  const { suppliersId } = useContext(SuppliersContext);

  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).resultPage;

  const titleHandler = () => {
    switch (suppliersId) {
      case SUPPLIERS_ID.mentalTherapy:
        return dictionary.therapy.title;
      case SUPPLIERS_ID.doctors:
        return dictionary.doctors.title;
      default:
        return '';
    }
  };

  return (
    <Typography
      variant='h3'
      component='h1'
      sx={{
        textAlign: 'center',
      }}
    >
      {dictionary.title} {titleHandler()}
    </Typography>
  );
};
